import { http } from '../../config/axios'

export default function getRegistroParticipacao(): Promise<any> {
  return http
    .get('api/registro/participacoes/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getParticipacao', error)
      throw Error(error.response.data)
    })
}
